import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCmakeComponent } from './simple-icons-cmake.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCmakeComponent ],
    exports:      [ SimpleIconsCmakeComponent ],
    bootstrap:    []
})
export class SimpleIconsCmakeModule {}
